




















































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";
import { notifyError } from "@/common/notify";

import { ValidationIniziativeMatrixElementSurvey } from "@/interfaces";
import { createProject } from "@/services";

const defaultProject = {
  title: "",
  description: "",
  initiatives: [],
  sendTo: false,
};

@Component
export default class CreateProjectDialog extends Vue {
  @Ref("create-project-dialog")
  dialog!: QDialog;

  @Prop({ type: Array, required: false })
  initiative!: ValidationIniziativeMatrixElementSurvey[];

  projectData = { ...defaultProject };

  file: any = null;

  loading = false;

  async onSubmit() {
    try {
      this.loading = true;

      const response = await createProject(this.projectData);
      const blob = new Blob([response.data], { type: response.data.type });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.projectData.title;
      link.click();
      URL.revokeObjectURL(link.href);

      /* notifySuccess("Operazione avvenuta con successo!"); */
      this.$emit("ok", true);
      this.projectData = { ...defaultProject };
      this.file = null;
      this.hide();
    } catch (e) {
      notifyError(`Si è verificato un errore durante la creazione del progetto`);
    } finally {
      this.loading = false;
    }
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
